//#region src/assets/shield.png
var shield_default = "" + new URL("shield-DYHyK8A0.png", import.meta.url).href;
//#endregion
export { shield_default as default };

//# sourceMappingURL=shield.js.map